/* eslint-disable max-len */

export function IconOutlook({ className }: { className?: string }) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.3953 5.45667V9.2221L14.7125 10.0505C14.7601 10.0608 14.8093 10.0608 14.8569 10.0505L20.5205 6.23216C20.5164 6.04685 20.4486 5.8686 20.3285 5.72738C20.2085 5.58616 20.0434 5.49057 19.8612 5.45667H13.3953Z"
        fill="currentColor"
      />
      <path
        d="M13.3952 10.6266L14.5963 11.4516C14.6524 11.486 14.717 11.5042 14.7829 11.5042C14.8488 11.5042 14.9134 11.486 14.9696 11.4516C14.7633 11.5761 20.5198 7.75427 20.5198 7.75427V14.6746C20.5348 14.8149 20.519 14.9567 20.4734 15.0902C20.4279 15.2237 20.3538 15.3456 20.2562 15.4474C20.1586 15.5492 20.04 15.6285 19.9086 15.6797C19.7771 15.7309 19.6361 15.7527 19.4954 15.7437H13.3945L13.3952 10.6266ZM7.17744 8.89071C6.9779 8.88982 6.78182 8.9429 6.60997 9.04432C6.43812 9.14573 6.29687 9.29172 6.20119 9.46684C5.93999 9.93114 5.81467 10.4596 5.83957 10.9917C5.81243 11.5228 5.93791 12.0505 6.20119 12.5125C6.29642 12.6804 6.43417 12.8203 6.6006 12.9182C6.76704 13.016 6.9563 13.0684 7.14936 13.0699C7.34242 13.0714 7.53249 13.0221 7.70045 12.9269C7.86842 12.8317 8.00838 12.694 8.10626 12.5276C8.36718 12.0679 8.4901 11.5428 8.46032 11.0151C8.4901 10.4709 8.37128 9.92877 8.11657 9.4469C8.0253 9.27765 7.88965 9.13645 7.7242 9.03846C7.55875 8.94047 7.36973 8.88939 7.17744 8.89071Z"
        fill="currentColor"
      />
      <path
        d="M1.48022 3.54406V18.2751L12.6865 20.625V1.375L1.48022 3.54406ZM8.97947 13.4001C8.76989 13.6956 8.49115 13.9354 8.1676 14.0985C7.84404 14.2616 7.48549 14.3431 7.12322 14.3357C6.77009 14.342 6.42066 14.2629 6.10466 14.1052C5.78866 13.9474 5.51543 13.7156 5.30822 13.4296C4.81684 12.7435 4.57101 11.9118 4.61041 11.0688C4.56871 10.1844 4.81898 9.31086 5.32266 8.58275C5.53507 8.28171 5.81821 8.03749 6.14717 7.87157C6.47612 7.70565 6.84082 7.62312 7.20916 7.63125C7.5597 7.62445 7.90656 7.70369 8.21938 7.86202C8.5322 8.02034 8.80144 8.25294 9.00354 8.53944C9.49001 9.24046 9.73166 10.0824 9.69104 10.9347C9.73406 11.8127 9.48372 12.68 8.97947 13.4001Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IconSidebar({ className }: { className?: string }) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1 12H11C11.55 12 12 11.55 12 11C12 10.45 11.55 10 11 10H1C0.45 10 0 10.45 0 11C0 11.55 0.45 12 1 12ZM0 1C0 1.55 0.45 2 1 2H11C11.55 2 12 1.55 12 1C12 0.45 11.55 0 11 0H1C0.45 0 0 0.45 0 1ZM1 7H11C11.55 7 12 6.55 12 6C12 5.45 11.55 5 11 5H1C0.45 5 0 5.45 0 6C0 6.55 0.45 7 1 7Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IconFullscreen({ className }: { className?: string }) {
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.0498 6.34961V11.9502H7.65039V13.6504H0.349609V6.34961H2.0498Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.3"
      />
      <path
        d="M12.9502 7.65039L12.9502 2.0498L7.34961 2.04981L7.34961 0.34961L14.6504 0.349609L14.6504 7.65039L12.9502 7.65039Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.3"
      />
    </svg>
  );
}

export function IconMinimize({ className }: { className?: string }) {
  return (
    <svg width="14" height="2" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect width="14" height="2" fill="currentColor" />
    </svg>
  );
}

export function IconBell({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8 16C9.1 16 10 15.1 10 14H6C6 15.1 6.9 16 8 16ZM14 10V6.5C14 4.02 12.49 1.89 10 1.18V0.5C10 -0.17 9.33 -0.5 8 -0.5S6 -0.17 6 0.5V1.18C3.51 1.89 2 4.02 2 6.5V10L0 12V13H16V12L14 10ZM12 11H4V6.5C4 4.57 5.57 3 8 3S12 4.57 12 6.5V11Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IconBellOff({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8 16C9.1 16 10 15.1 10 14H6C6 15.1 6.9 16 8 16ZM14 10V6.5C14 4.02 12.49 1.89 10 1.18V0.5C10 -0.17 9.33 -0.5 8 -0.5S6 -0.17 6 0.5V1.18C3.51 1.89 2 4.02 2 6.5V10L0 12V13H16V12L14 10ZM12 11H4V6.5C4 4.57 5.57 3 8 3S12 4.57 12 6.5V11Z"
        fill="currentColor"
        opacity="0.4"
      />
      <path d="M2 1L1 2L15 16L16 15L2 1Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
